import styled from 'styled-components';

export const FilterRows = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const CounterRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 3px;
  align-items: center;
`;

export const ResultsCounter = styled.div`
  flex: 1;
`;

export const UsersListWrapper = styled.div`
  margin-top: 15px;
`;
